
import { useState, useEffect } from 'react';

export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    setTimeout(() => setIsVisible(true), 200);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  const scrollToContactMiddle = () => {
    const contactEl = document.getElementById('contacto');
    const coberturaEl = document.getElementById('cobertura');
    if (coberturaEl) {
      const coberturaRect = coberturaEl.getBoundingClientRect();
      const coberturaTop = window.scrollY + coberturaRect.top;
      const contactBottom = contactEl ? window.scrollY + contactEl.getBoundingClientRect().bottom : coberturaTop + 1000;
      const midPoint = (coberturaTop + contactBottom) / 2 - window.innerHeight / 2;
      window.scrollTo({ top: midPoint, behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { label: 'Soporte', action: () => scrollToSection('soporte-remoto') },
    { label: 'Servicios', action: () => scrollToSection('servicios') },
    { label: 'Ayuda Inmediata', action: () => scrollToSection('ayuda-inmediata') },
    { label: 'Nosotros', action: () => scrollToSection('nosotros') },
    { label: 'Contacto', action: () => scrollToContactMiddle() },
  ];

  return (
    <nav className={`fixed w-full top-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-gray-950/95 backdrop-blur-md shadow-neon-sm' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className={`flex items-center transition-all duration-700 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-6'}`}>
            <button onClick={() => scrollToSection('hero')} className="flex items-center cursor-pointer">
              <span className="hidden sm:inline text-base sm:text-xl font-semibold whitespace-nowrap text-white">
                Servicio Técnico IT
              </span>
            </button>
          </div>

          <div className={`hidden md:flex items-center space-x-8 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}>
            {navItems.map((item, i) => (
              <button
                key={item.label}
                onClick={item.action}
                className="text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-white hover:text-neon-400 relative group"
                style={{ transitionDelay: `${i * 60}ms` }}
              >
                {item.label}
                <span className="absolute -bottom-1 left-0 w-0 h-px bg-neon-400 transition-all duration-300 group-hover:w-full"></span>
              </button>
            ))}
          </div>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl text-white transition-transform duration-300`}></i>
          </button>
        </div>
      </div>

      <div className={`md:hidden overflow-hidden transition-all duration-400 ${isMobileMenuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="bg-gray-950/95 backdrop-blur-md border-t border-neon-400/20 px-4 py-4 space-y-3">
          {navItems.map((item) => (
            <button
              key={item.label}
              onClick={item.action}
              className="block w-full text-left text-sm font-medium text-gray-300 hover:text-neon-400 py-2 cursor-pointer transition-colors"
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
}
